import { ConversationIdSchema } from '@plato/shared';
import { useState } from 'react';
import { Page } from '../../components/page.tsx';
import { useHashRoute } from '../../shell/use-current-section.ts';
import { ConversationDetail } from './conversation-detail.tsx';
import { ConversationList } from './conversation-list.tsx';
import { ToolHealth } from './tool-health.tsx';
import './conversations.css';

export function ConversationsSection() {
  const route = useHashRoute();
  const conversation = ConversationIdSchema.safeParse(route.path[0]);
  const user = route.params.get('user');
  if (conversation.success && user !== null) {
    return <ConversationDetail conversationId={conversation.data} userId={user} />;
  }
  return <ConversationsOverview />;
}

function ConversationsOverview() {
  const [view, setView] = useState<'conversations' | 'tools'>('conversations');
  return (
    <Page
      title="Conversations"
      summary="Your users' conversations with the assistant, what the model saw and did in each, and how your tools are holding up. Opening a conversation is recorded in Activity."
    >
      <div className="tabs" role="tablist" aria-label="Conversations views">
        <button
          type="button"
          role="tab"
          aria-selected={view === 'conversations'}
          onClick={() => setView('conversations')}
        >
          Conversations
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={view === 'tools'}
          onClick={() => setView('tools')}
        >
          Tool health
        </button>
      </div>
      <div role="tabpanel">{view === 'conversations' ? <ConversationList /> : <ToolHealth />}</div>
    </Page>
  );
}
